import script from "./UpsertCollection.vue?vue&type=script&setup=true&lang=js"
export * from "./UpsertCollection.vue?vue&type=script&setup=true&lang=js"

import "./UpsertCollection.vue?vue&type=style&index=0&id=050253bc&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-050253bc"]])

export default __exports__